import { ADVANCED_FILTERS_TRIGGER_ID } from './AdvancedFilters'

// Two ways to render the Advanced Filters trigger: the full "Advanced Filters"
// label (Task Management, Rentals/Returns, and Object Permissions -- pages with
// header room to spare, or no search box for a compact trigger to sit beside) and
// a compact icon-only variant with just an applied count (everywhere else,
// including Incidents/claim listing pages, where header space is tight).
function AdvancedFiltersTrigger({ count, onClick, compact = false }) {
    if (compact) {
        return (
            <a
                id={ADVANCED_FILTERS_TRIGGER_ID}
                className="driver-list-button advanced-filters-trigger--compact"
                onClick={onClick}
                title="Advanced Filters"
            >
                <i className="fa fa-sliders" aria-hidden="true"></i> | {count}
            </a>
        )
    }

    return (
        <a
            id={ADVANCED_FILTERS_TRIGGER_ID}
            className="driver-list-button"
            onClick={onClick}
            style={{ whiteSpace: 'nowrap' }}
        >
            Advanced Filters | <i className="fa fa-sliders" aria-hidden="true"></i> {count}
        </a>
    )
}

export default AdvancedFiltersTrigger
